import PropTypes from 'prop-types';

import { Button } from '#/modules/commonComponents/button';
import {
  Command,
  CommandEmpty,
  CommandInput,
  CommandList,
} from '#/modules/commonComponents/shadcn/ui/command';

function MultiSelectFilterList({
  shouldFilter = true,
  showCommandInput = false,
  commandInputPlaceholder = '搜尋...',
  commandInputValue,
  onCommandInputValueChange,
  isLoading = false,
  loadingText = '載入中...',
  children,
  onClear,
}) {
  const isControlledInput = onCommandInputValueChange !== undefined;

  return (
    <div
      className="flex flex-col"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      onWheel={(event) => event.stopPropagation()}
      onTouchMove={(event) => event.stopPropagation()}
    >
      <Command shouldFilter={shouldFilter}>
        {showCommandInput ? (
          <CommandInput
            placeholder={commandInputPlaceholder}
            {...(isControlledInput ? {
              value: commandInputValue,
              onValueChange: onCommandInputValueChange,
            } : {})}
          />
        ) : null}
        <CommandList
          className="max-h-60 min-h-0"
          onWheel={(event) => event.stopPropagation()}
          onTouchMove={(event) => event.stopPropagation()}
        >
          {isLoading ? (
            <div className="px-3 py-2 text-xs text-muted-foreground">{loadingText}</div>
          ) : null}
          <CommandEmpty>無符合項目</CommandEmpty>
          {children}
        </CommandList>
      </Command>
      <div className="border-t border-slate-300 px-2 py-1">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 w-full px-2 text-xs"
          onClick={onClear}
        >
          清除
        </Button>
      </div>
    </div>
  );
}

MultiSelectFilterList.propTypes = {
  shouldFilter: PropTypes.bool,
  showCommandInput: PropTypes.bool,
  commandInputPlaceholder: PropTypes.string,
  commandInputValue: PropTypes.string,
  onCommandInputValueChange: PropTypes.func,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
  children: PropTypes.node,
  onClear: PropTypes.func.isRequired,
};

export default MultiSelectFilterList;
